import { ReactComponent as EvCharger } from '@/src/resources/rewards/ev-charger.svg';
import { ReactComponent as CakeSlice } from '@/src/resources/rewards/cake-slice.svg';
import { ReactComponent as UKMap } from '@/src/resources/rewards/uk-map.svg';
import { ReactComponent as Coins } from '@/src/resources/rewards/coins.svg';
import { ReactComponent as Prize } from '@/src/resources/rewards/prize.svg';
import { ReactComponent as Boiler } from '@/src/resources/rewards/boiler.svg';
import { ReactComponent as LightBulb } from '@/src/resources/rewards/light-bulb.svg';
import { ReactComponent as SolarPanel } from '@/src/resources/rewards/solar-panel.svg';
import { ReactComponent as HeatPump } from '@/src/resources/rewards/heat-pump.svg';
import { ReactComponent as EvCharging } from '@/src/resources/rewards/ev-charging.svg';

import { RewardProductId } from '@/src/api/use-rewards-query';

export const NON_ACTIVATED_USERS_DEFAULT_CONTENT = [
  {
    Icon: EvCharger,
    title: 'Smart EV charging',
    text: 'Charge smarter, save up to £542 a year - all from your OVO account.',
  },
  {
    Icon: CakeSlice,
    title: 'Get rewarded',
    text: 'Freebies, discounts, offers, you name it. Get free perks with Beyond.',
  },
  {
    Icon: UKMap,
    title: 'Trusted by millions',
    text: 'Join over 4 million UK homes who trust OVO to power their home.',
  },
  {
    Icon: Coins,
    title: 'Price cap promise',
    text: 'Stick with us and pay below the energy price cap until 2026.',
  },
];

export const ACTIVATED_USERS_WITHOUT_REWARDS_DEFAULT_CONTENT = [
  {
    Icon: Prize,
    title: 'Win prizes',
    text: 'From energy credits to a free TV, we regularly give our customers the chance to get even more.',
  },
  {
    Icon: CakeSlice,
    title: 'Free rewards',
    text: 'Keep earning free solar panels and up to 2,400 EV miles to use later.',
  },
  {
    Icon: Boiler,
    title: 'Save on heating',
    text: 'Cosy up for less with discounted boiler cover and a free annual service.',
  },
  {
    Icon: LightBulb,
    title: 'Enjoy extras',
    text: 'Gig tickets, discounts on smart tech, and loads more. \nJust for being with us.',
  },
];

const ACTIVE_REWARD_FULLY_ACCRUED_TEXT =
  ' accrued. Move with us and keep getting rewarded.';
const ACTIVE_REWARD_PARTIALLY_ACCRUED_TEXT =
  ' so far. Move with us to keep earning.';

const createActiveRewardText = ({
  currentLevel,
  maxLevel,
  includeMaxLevel,
  unit,
}: {
  currentLevel: number;
  maxLevel: number;
  includeMaxLevel: boolean;
  unit: string;
}) => {
  let text = `${currentLevel.toLocaleString()}`;
  if (includeMaxLevel) {
    text += ` of ${maxLevel.toLocaleString()}`;
  }
  text += ` ${unit}`;

  if (currentLevel === maxLevel) {
    text += ACTIVE_REWARD_FULLY_ACCRUED_TEXT;
  } else {
    text += ACTIVE_REWARD_PARTIALLY_ACCRUED_TEXT;
  }

  return text;
};

export const ACTIVE_REWARDS_CONTENT = [
  {
    productId: RewardProductId.solarReward,
    Icon: SolarPanel,
    title: 'Free solar panels',
    text: (currentLevel: number, maxLevel: number) =>
      createActiveRewardText({
        currentLevel,
        maxLevel,
        includeMaxLevel: true,
        unit: 'solar panels',
      }),
  },
  {
    productId: RewardProductId.heatReward,
    Icon: HeatPump,
    title: 'Free heating credit',
    text: (currentLevel: number, maxLevel: number) =>
      createActiveRewardText({
        currentLevel,
        maxLevel,
        includeMaxLevel: false,
        unit: 'months of heat pump credit',
      }),
  },
  {
    productId: RewardProductId.evReward,
    Icon: EvCharging,
    title: 'Free EV miles',
    text: (currentLevel: number, maxLevel: number) =>
      createActiveRewardText({
        currentLevel,
        maxLevel,
        includeMaxLevel: true,
        unit: 'miles',
      }),
  },
];

export const REMAINING_DEFAULT_CONTENT_WHEN_SOME_REWARDS_ACTIVE = [
  {
    Icon: LightBulb,
    title: 'Enjoy extras',
    text: 'Gig tickets, discounts on smart tech, and loads more. \nJust for being with us.',
  },
  {
    Icon: Prize,
    title: 'Win prizes',
    text: 'From energy credits to a free TV, we regularly give our customers the chance to get even more.',
  },
  {
    Icon: Boiler,
    title: 'Save on heating',
    text: 'Cosy up for less with discounted boiler cover and a free annual service.',
  },
];
